<template>
  <div>
    <embed-api-table
      title="Client Search Results (Positive/Negative Links)"
      module="Client-Pages"
      v-bind:custom-data-source="customDataSource"
      v-bind:add-new-text="addNewText"
      v-bind:per-page="perPage"
      @add-new="addNew"
      @itemUpdated="onClientPageUpdated"
      default-sort="createdAt DESC"
      v-bind:columns="pagesColumns"
      v-bind:filter="pagesFilter"
      v-bind:refresh-for-id="lastRefreshTime">
    </embed-api-table>
    
    <add-client-page @added="onClientPagesAdded" v-bind:client-id="clientId"></add-client-page>
  </div>
</template>

<script>
  import EmbedApiTable from "./EmbedApiTable.vue";
  import AddClientPage from "./AddClientPage.vue";
  import EditStringDlg from "./EditStringDlg.vue";
  import WebLLCRESTApi from "../api/api";
  import $ from "jquery";
  
  import imgPositive from "../assets/plus.svg";
  import imgNeutral from "../assets/equals.svg";
  import imgNegative from "../assets/minus.svg";
  
  export default {
    created() {
      // prepare api
      this.api = new WebLLCRESTApi("Client-Pages", this.$router);
    },
    
    props: {
      clientId: String,
      source: String,
      mangoolsData: Array,
      viewMangoolsData: Boolean,
      canSave: Boolean
    },
    
    data() {
      return {
        addNewText: (this.canSave ? "Add New Link" : null),
        
        pagesColumns: this.getColumns(),
        
        pagesFilter: { category: "link", clientId: this.clientId },
        
        curEditingLinkId: "",
        curEditingLink: "",
        
        customDataSource: (this.source == "mangoolsData" ? this.getTemporaryDataSource() : null),
        perPage: (this.source == "mangoolsData" ? 20 : 10),
        
        lastRefreshTime: "0"
      };
    },
    
    methods: {
      addNew() {
        $('#modal-add-page-data').modal('toggle');
      },
      
      onClientPagesAdded() {
        // change the last refresh date so the table refreshes
        this.lastRefreshTime = Date.now().toString();
      },
      
      async onClientPageUpdated(data) {
        if(data.col.key == "linkType") {
          if(this.source !== "mangoolsData") {
            await this.api.updateData(data.item.item.id, {
              linkType: data.newValue
            });
          }
          else {
            for(const page of this.mangoolsData) {
              for(const item of page.items) {
                if(item.url == data.item.item.url) {
                  item.linkType = data.newValue;
                }
              }
            }
          }
        }
        
        this.$emit('itemUpdated', data);
      },
      
      getColumns() {
        const cols = [
          {
            key: "linkType",
            text: "Positive/Negative",
            type: "ImageOptions",
            options: [
              { key: "positive", value: "Positive", img: imgPositive, class: "green-option" },
              { key: "negative", value: "Negative", img: imgNegative, class: "red-option" },
              { key: "neutral", value: "Neutral", img: imgNeutral, class: "orange-option" }
            ],
            editable: this.source == "mangoolsData",
            sort: true
          },
          { key: "url", "text": "URL", type: "URL", sort: true },
        ];
        
        if(this.viewMangoolsData) {
          cols.push({ key: "mangoolsDA", "text": "Domain Authority", type: "String", sort: true });
          cols.push({ key: "mangoolsPos", "text": "Mangools Pos", type: "String", sort: true });
        }
        
        if(this.canSave && this.source !== "mangoolsData") {
          cols.unshift({ key: "bulkdelete", "text": "", type: "BulkDelete" });
          cols.push({ key: "delete", "text": "Delete", type: "Delete", sort: false });
        }
        
        return cols;
      },
      
      getTemporaryDataSource() {       
        return {
          getData: (refreshPageCount, page, perPage) => {
            if(this.mangoolsData) {
              const data = [].concat.apply([], this.mangoolsData.map((page, pageNo) => page.items.map((item, index) => {
                const pos = (pageNo * 10) + index;
                
                return {
                  type: item.type,
                  linkType: "",
                  url: item.url,
                  title: item.title,
                  mangoolsDA: (item.m && item.m.moz ? item.m.moz.v.pda : ""),
                  mangoolsPos: (pos + 1),
                  pos: pos,
                  page: (pageNo + 1),
                  createdAt: new Date(this.mangoolsData[0].created_at * 1000)
                };
              })))
              .filter((item) => item.type === "ORGANIC" )
              .filter((item, index) => index >= (page * perPage) && index < ((page + 1) * perPage) );
              
              return {
                data: data,
                totalCount: data.length
              };
            }
            else {
              return {
                data: [],
                totalCount: 0
              };
            }
          }
        };
      }
    },
    
    watch: {
      canSave(to, from) {
        this.addNewText = (this.canSave ? "Add New Page" : null);
        this.pagesColumns = this.getColumns();
      },
      
      mangoolsData(to) {
        this.lastRefreshTime = Date.now().toString();
      }
    },

    components: {
      EmbedApiTable,
      AddClientPage,
      EditStringDlg
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ClientPagesTable.vue